// Finetomi — Central branding configuration.
// Change the brand here (name, tagline, colors, onboarding copy) without touching app code.
export const BRANDING = {
  name: "Finetomi",
  tagline: "Your Financial Home",
  domain: "finetomi.com",
  siteUrl: "https://finetomi.com",
  inboxEmail: "receipts@inbound.finetomi.com",
  version: "Beta v1.0.2",
  logo: null, // optional URL; falls back to wordmark
  onboarding: {
    welcomeTitle: "Welcome to your Financial Operating System.",
    welcomeBody:
      "Finetomi is one calm, secure home for every part of your financial life — income, savings, documents, investments and more. Let's set up your home.",
    finishTitle: "Your Financial Home is ready.",
  },
  // Light-luxury palette (hotel lobby / jewellery boutique)
  colors: {
    babyBlue: "#E9F1F8",
    ivory: "#FBF7F1",
    champagne: "#C6A45C",
    champagneSoft: "#D8BE83",
    taupe: "#B79B86",
    nude: "#E7D8C9",
    charcoal: "#2C2A28",
    secondaryText: "#8A7F70",
    border: "#EAE0D2",
    success: "#8FB996",
    rose: "#C99FA0",
  },
  chartPalette: ["#C6A45C", "#9FB8C9", "#B79B86", "#C99FA0", "#A8B79B", "#D8C9B0"],
};

// Subscription plans (Stripe deferred — selection only for now).
export const PLANS = [
  {
    key: "personal", name: "Personal Finance", price: 11,
    tagline: "Everyday income, spending, savings & goals",
    features: ["Cash flow & budgeting", "Savings goals", "Financial Inbox (receipts & bills)",
               "AI insights & advisory team", "PDF · Word · Excel exports"],
  },
  {
    key: "investor", name: "Investor", price: 19, featured: true,
    tagline: "Properties, portfolio, insurance & tax-ready reports",
    features: ["Everything in Personal", "Property & mortgage tracking", "Investment portfolio & dividends",
               "Insurance & maintenance reminders", "Supplier invoices & tax-ready reports"],
  },
  {
    key: "community", name: "Community", price: 39,
    tagline: "Bookings, committee, reimbursements & reports",
    features: ["Everything in Investor", "Accommodation bookings & calendar", "Committee & member management",
               "Reimbursements & booking ledger", "Treasurer dashboard & annual reports"],
  },
];

// Centrally managed legal disclaimer (mirrors backend core/disclaimer.py).
export const DISCLAIMER = {
  heading: "Important Information",
  body: [
    "The information, reports, forecasts and insights provided by Finetomi are intended for general informational and educational purposes only.",
    "Finetomi is a financial organisation and productivity platform. It is not a licensed financial adviser, accountant, tax agent, lawyer, mortgage broker, insurance adviser or investment adviser.",
    "Any insights, recommendations, summaries or forecasts generated within Finetomi are based solely on the information you choose to provide and may be incomplete or inaccurate.",
    "Before making financial, taxation, legal, lending, insurance or investment decisions, you should obtain advice from an appropriately qualified professional who understands your personal circumstances.",
    "While Finetomi is designed to help you organise and better understand your financial information, responsibility for all financial decisions remains with you.",
  ],
  short: "General Information Only — Finetomi does not provide personal financial, taxation, legal or investment advice.",
};

export const WELCOME_LINES = [
  "Welcome home.",
  "Your finances are organised.",
  "Your Financial Home is up to date.",
  "You're ready for tax time.",
  "Your latest documents have been safely added.",
];
